<template>
  <div class="container" v-if="showTabs">
    <div class="row">
      <div class="w-auto mx-auto">
        <nav class="nav nav-pills flex-row media-tabs">
            <span class="flex-fill text-center nav-link"
                  :class="{ active: currentTab === checkinTabs.BUYABLE }"
                  @click="onSelect(checkinTabs.BUYABLE)"
                  v-if="paidGalleriesMediasCount>0">
              {{ $t('pages.checkins_detail.not_purchased_yet') }}
            </span>
          <span class="flex-fill text-center nav-link"
                :class="{ active: currentTab === checkinTabs.BOUGHT }"
                @click="onSelect(checkinTabs.BOUGHT)"
                v-if="unlockedGalleriesMediasCount>0">
            <template v-if="paidGalleriesMediasCount>0">
                {{ $t('pages.checkins_detail.purchased') }} ({{ unlockedGalleriesMediasCount }})
            </template>
            <template v-else>
                {{ $t('pages.checkins_detail.all_photos') }}
            </template>

                </span>
          <span class="flex-fill text-center nav-link"
                :class="{ active: currentTab === checkinTabs.FAVORITE }"
                @click="onSelect(checkinTabs.FAVORITE)"
                v-if="favoriteGalleriesMediasCount>0">
                  {{ $t('pages.checkins_detail.favorites') }} ({{ favoriteGalleriesMediasCount }})
                </span>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {checkinTabs} from "@/domain/galleries/constants";

export default {
  name: "MediaTabs",
  emits: ['select'],
  data() {
    return {
      currentTab: checkinTabs.BOUGHT
    }
  },
  watch: {
    paidGalleries: {
      immediate: true,
      handler(value) {
        if (value && value.length > 0) {
          // If there are medias to buy, select the buyable tab
          if (this.paidGalleriesMediasCount > 0) {
            this.onSelect(checkinTabs.BUYABLE)
          }
          // If there are no medias bought, and there galleries with a price list is presale
          else if (this.unlockedGalleriesMediasCount === 0 && this.paidGalleries && this.paidGalleries.length > 0) {
            this.onSelect(checkinTabs.BUYABLE)
          }
        }
      }
    },
    favoriteGalleriesMediasCount(value) {
      // no favorite galleries, select the bought/unlocked tab
      if (value < 1) {
        this.onSelect(checkinTabs.BOUGHT)
      }
    }
  },
  computed: {
    ...mapGetters('galleries', [
      'unlockedGalleriesMediasCount',
      'paidGalleriesMediasCount',
      'favoriteGalleriesMediasCount',
      'paidGalleries'
    ]),
    checkinTabs() {
      return checkinTabs
    },
    showTabs() {
      return (this.unlockedGalleriesMediasCount > 0 && this.paidGalleriesMediasCount > 0) || this.favoriteGalleriesMediasCount > 0
    }
  },
  methods: {
    onSelect(tab) {
      this.currentTab = tab
      this.$emit('select', tab)
    }
  }
}
</script>


<style scoped>

</style>